import { render, staticRenderFns } from "./Extensions.vue?vue&type=template&id=554e9e2a"
import script from "./Extensions.vue?vue&type=script&lang=js"
export * from "./Extensions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports